export const CONFIG_ELEMENT_ID = 'analytics-provider-data';
export const PARTIAL_VIEW_CONFIG_ELEMENT_ID = 'analytics-provider-data-partial';
